<div class="main-div">
  <div>
    <span class="aling-img">
      <img src="http://ibolthost.com.br/logos/logo_Biotech.png" alt="Biotech" />
    </span>
    <mat-card color="primary" class="mat-elevation-z8">
      <mat-card-title style="height: 55px" layout-align="center center">
        <h1>Acesso ao Sistema</h1>
      </mat-card-title>

      <form [formGroup]="loginForm" class="form" (submit)="login()">
        <mat-card-content>
          <mat-form-field class="input-full-width">
            <mat-placeholder>
              <mat-icon> perm_identity</mat-icon>usuário
            </mat-placeholder>
            <input
              autocomplete="off"
              matInput
              autofocus
              formControlName="userName"
            />
            <mat-error *ngIf="loginForm.get('userName').errors"
              >usuário deve ter mais de 3 letras</mat-error
            >
          </mat-form-field>
          <mat-form-field class="input-full-width">
            <mat-placeholder>
              <mat-icon>visibility</mat-icon>senha
            </mat-placeholder>
            <input
              autocomplete="off"
              matInput
              type="password"
              formControlName="password"
            />
            <mat-error *ngIf="loginForm.get('password').errors"
              >senha deve ter mais de 5 letras</mat-error
            >
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
          <mat-grid-list cols="1" rowHeight="50px">
            <mat-grid-tile>
              <button
                *ngIf="!load; else spin"
                type="submit"
                mat-flat-button
                color="primary"
                [disabled]="loginForm.invalid"
              >
                <!-- <mat-icon>input</mat-icon> -->
                <span>Entrar</span>
              </button>
            </mat-grid-tile>
            <mat-grid-tile>
              <a href="#" routerLink="/esqueci-senha/solicitar"
                >Esqueci minha senha</a
              >
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card-actions>
      </form>
    </mat-card>
  </div>
</div>

<!-- <footer>Curityba Biotech | Rua Prof. Pedro Viriato Parigot de Souza, 5300 – Bloco Marrom Sala 111 Curitiba, PR 81280-330</footer> -->
<!-- Botão que mostra para o usuário assim que o download iniciar -->
<ng-template #spin>
  <button mat-raised-button color="primary" title="Clique para entrar">
    Entrando...&nbsp;&nbsp;
    <app-spinner-angularmaterial></app-spinner-angularmaterial>
  </button>
</ng-template>
